module.exports = __webpack_public_path__ + "imgs/leafwell2.2e81c1c7aa0b499adf9b633cc0c468e5.svg";